import React, { useState } from 'react';
import styles from './filter-request-list.module.scss';
import { FormElementData } from '../../../../../shared/interfaces/form-element-data.interface';
import {
  InputText,
  InputTextErrorMode
} from '../../../../../shared/components/core-ui/input-text/input-text.component';

import { FormControl, createStyles, Theme, makeStyles } from '@material-ui/core';
import Button, {
  ButtonSize
} from '../../../../../shared/components/core-ui/button/button.component';
import ReactDatePicker from 'react-datepicker';

export interface FilterRequestListrModel {
  name?: string;
  phoneNumber?: string;
  checkInDate?: number;
  checkOutDate?: number;
  creationDateFrom?: number;
  creationDateTo?: number;
}

export interface FilterRequestListProps {
  eventHandlers: {
    search: (filterModel: FilterRequestListrModel) => void;
  };
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0,
      '& .MuiFormControl-root': {
        width: '100%'
      }
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    }
  })
);
/**
 * functional component FilterRequestList
 * @param {FilterRequestListProps}
 */
export const FilterRequestList: React.FC<FilterRequestListProps> = ({ eventHandlers }) => {
  const classes = useStyles();

  const [name, setName] = useState<FormElementData<string>>({
    value: '',
    isValid: false,
    changed: false
  });

  const [checkInDate, setCheckInDate] = useState<Date>();
  const [checkOutDate, setCheckOutDate] = useState<Date>();
  const [creationAtFrom, setCreationAtFrom] = useState<Date>();
  const [creationAtTo, setCreationAtTo] = useState<Date>();
  const [phoneNumber, setPhoneNumber] = useState<string>('');

  return (
    <div className={styles['filter-request-list']}>
      <div className={styles['filter-request-list__form']}>
        <FormControl variant="outlined" className={classes.formControl}>
          <div className={styles['filter-request-list__form__label']}>Guest Name</div>
          <InputText
            data={{
              value: name.value,
              placeholder: 'Guest Name'
            }}
            config={{
              maxRows: 1,
              autoFocus: false,
              showErrorMode: InputTextErrorMode.instant
            }}
            eventHandlers={{
              onChangeHandler: (value: string, isValid: boolean) => {
                setName({ value, isValid });
              }
            }}
          />
        </FormControl>
        <FormControl variant="outlined" className={classes.formControl}>
          <div className={styles['filter-request-list__form__label']}>Phone Number</div>
          <InputText
            data={{
              value: phoneNumber,
              placeholder: 'Phone Number'
            }}
            config={{
              maxRows: 1,
              autoFocus: false,
              showErrorMode: InputTextErrorMode.instant
            }}
            eventHandlers={{
              onChangeHandler: (value: string, isValid: boolean) => {
                setPhoneNumber(value);
              }
            }}
          />
        </FormControl>
        <FormControl variant="outlined" className={classes.formControl}>
          <div className={styles['filter-request-list__form__label']}>Check In / Check Out</div>
          <div className={styles['filter-request-list__date-range']}>
            <ReactDatePicker
              selected={checkInDate}
              onChange={(date: Date) => {
                setCheckInDate(date);
                setCheckOutDate(undefined);
              }}
              selectsStart
              startDate={checkInDate}
              endDate={checkOutDate}
              placeholderText="check In"
            />
            <ReactDatePicker
              selected={checkOutDate}
              onChange={(date: Date) => {
                setCheckOutDate(date);
              }}
              selectsEnd
              startDate={checkInDate}
              endDate={checkOutDate}
              minDate={checkInDate}
              placeholderText="Check Out"
            />
          </div>
        </FormControl>
        <FormControl variant="outlined" className={classes.formControl}>
          <div className={styles['filter-request-list__form__label']}>Creation Date</div>
          <div className={styles['filter-request-list__date-range']}>
            <ReactDatePicker
              selected={creationAtFrom}
              onChange={(date: Date) => {
                setCreationAtFrom(date);
                setCreationAtTo(undefined);
              }}
              selectsStart
              startDate={creationAtFrom}
              endDate={creationAtTo}
              placeholderText="From"
            />
            <ReactDatePicker
              selected={creationAtTo}
              onChange={(date: Date) => {
                setCreationAtTo(date);
              }}
              selectsEnd
              startDate={creationAtFrom}
              endDate={creationAtTo}
              minDate={creationAtFrom}
              placeholderText="To"
            />
          </div>
        </FormControl>
      </div>
      <div className={styles['filter-request-list__actions']}>
        <Button
          onClick={() => {
            eventHandlers?.search({
              name: name.value,
              phoneNumber: phoneNumber || undefined,
              checkInDate: checkInDate?.getTime(),
              checkOutDate: checkOutDate?.getTime(),
              creationDateFrom: creationAtFrom?.getTime(),
              creationDateTo: creationAtTo?.getTime()
            });
          }}
          size={ButtonSize.medium}
        >
          Search
        </Button>
        <Button
          onClick={() => {
            setName({
              value: '',
              isValid: false,
              changed: false
            });
            setCheckInDate(undefined);
            setCheckOutDate(undefined);
            setCreationAtFrom(undefined);
            setCreationAtTo(undefined);
            setPhoneNumber('');

            eventHandlers?.search({} as FilterRequestListrModel);
          }}
          size={ButtonSize.medium}
        >
          Clear
        </Button>
      </div>
    </div>
  );
};
